"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.MilestoneProgress = void 0;
var moment = require("moment");
var common_1 = require("../../schemas/common");
var milestone_1 = require("../../schemas/milestone");
var common_2 = require("../common");
var milestone_timeframe_1 = require("./milestone-timeframe");
var MilestoneProgress = /** @class */ (function (_super) {
    __extends(MilestoneProgress, _super);
    function MilestoneProgress(props, milestone, dog) {
        if (props === void 0) { props = {}; }
        return _super.call(this, __assign(__assign({}, MilestoneProgress.defaultProps(milestone, dog)), props)) || this;
    }
    /**
     * Get absolute timeframe
     */
    MilestoneProgress.absoluteTimeframe = function (milestone, dog, dogSize) {
        if (dogSize === void 0) { dogSize = null; }
        // Start = Subtract dog's date of birth from timeline start from birth
        // End = Add timeline duration to Start
        var minStartd = moment.duration(milestone.timeline.min, milestone.timeline.unit);
        var maxStartd = moment.duration(milestone.timeline.max, milestone.timeline.unit);
        if (milestone.timeline.breedSizeOffets && dogSize) {
            minStartd.add(moment.duration(milestone.timeline.breedSizeOffets[dogSize].value, milestone.timeline.breedSizeOffets[dogSize].unit));
            maxStartd.add(moment.duration(milestone.timeline.breedSizeOffets[dogSize].value, milestone.timeline.breedSizeOffets[dogSize].unit));
        }
        var minStart = moment(dog.dob).add(minStartd);
        var maxStart = moment(dog.dob).add(maxStartd);
        var minEnd = moment(minStart).add(milestone.duration.min, milestone.duration.unit);
        var maxEnd = moment(maxStart).add(milestone.duration.max, milestone.duration.unit);
        return {
            start: milestone_timeframe_1.MilestoneTimeframe.defaultProps(minStart.toDate(), maxStart.toDate()),
            end: milestone_timeframe_1.MilestoneTimeframe.defaultProps(minEnd.toDate(), maxEnd.toDate())
        };
    };
    MilestoneProgress.defaultState = function (milestone, dog, start, end) {
        var s = start;
        var e = end;
        if (!s || !e) {
            var results = MilestoneProgress.absoluteTimeframe(milestone, dog);
            s = results.start;
            e = results.end;
        }
        // Check between max end date and min start date
        if (moment().diff(moment(e.date.max), 'weeks') > 0) {
            return milestone_1.MilestoneState.EXPIRED; // Already passed
        }
        else if (moment().diff(moment(s.date.min)) < 0) {
            return milestone_1.MilestoneState.UNAVAILABLE;
        }
        else {
            return milestone_1.MilestoneState.AVAILABLE;
        }
    };
    MilestoneProgress.isStaged = function (milestone) {
        switch (milestone.severity) {
            case common_1.Severity.CRITICAL:
            case common_1.Severity.MAJOR:
                return true;
            case common_1.Severity.OPTIONAL:
            case common_1.Severity.MINOR:
                return false;
            default:
                console.error("Milestone \"" + milestone.id + "\" provided invalid severity \"" + milestone.severity + "\"");
                return false;
        }
    };
    MilestoneProgress.defaultProps = function (milestone, dog) {
        if (!dog.dob) {
            throw new Error('Dog must provide their date of birth');
        }
        var _a = MilestoneProgress.absoluteTimeframe(milestone, dog), start = _a.start, end = _a.end;
        return __assign(__assign({}, common_2.AbstractModel.defaultBaseProps()), { id: milestone.id, milestone: milestone.id, staged: MilestoneProgress.isStaged(milestone), state: MilestoneProgress.defaultState(milestone, dog, start, end), completed: null });
    };
    return MilestoneProgress;
}(common_2.AbstractModel));
exports.MilestoneProgress = MilestoneProgress;
